"use client";

import { useEffect, useState, startTransition } from "react";
import { initGTM } from "@/lib/analytics";
import Link from "next/link";
import { Button } from "@/components/ui/button";

const COOKIE_NAME = "cookie-consent";
const COOKIE_EXPIRY_DAYS = 365;

export function CookieConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    startTransition(() => {
      setMounted(true);
      const consent = getCookie(COOKIE_NAME);
      if (!consent) {
        setShowBanner(true);
      } else if (consent === "accepted") {
        initGTM();
      }
    });
  }, []);

  const acceptCookies = () => {
    setCookie(COOKIE_NAME, "accepted", COOKIE_EXPIRY_DAYS);
    setShowBanner(false);
    initGTM();
  };

  const declineCookies = () => {
    setCookie(COOKIE_NAME, "declined", COOKIE_EXPIRY_DAYS);
    setShowBanner(false);
  };

  if (!mounted || !showBanner) {
    return null;
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] bg-background border-t border-border shadow-lg"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="container mx-auto px-4 md:px-6 py-4 md:py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm md:text-base text-foreground">
              We use cookies to enhance your browsing experience and analyze
              site traffic. By clicking &quot;Accept&quot;, you consent to our
              use of cookies.{" "}
              <Link
                href="/cookies"
                className="text-accent hover:underline font-medium"
              >
                Cookie Policy
              </Link>
            </p>
          </div>
          <div className="flex gap-3 w-full md:w-auto">
            <Button variant="ghost" onClick={declineCookies}>
              Decline
            </Button>
            <Button onClick={acceptCookies}>Accept</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

function setCookie(name: string, value: string, days: number): void {
  if (typeof document === "undefined") return;
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}





